import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Raziskava",
  "description": "",
  "published": "2007-01-18T00:00:00.000Z",
  "redirect_from": ["/blog/raziskava/swizec/318"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Javna zabava, kot naprimer nanizanke in filmi, ponavadi zelo razisce tematiko svojega dela, tako bi nekdo, ki dela film o raverjih, mocno raziskal rave in to kulturo, prav tako pa bi se v tematiko poglobili vsi igralci in pravzaprav vsi, ki imajo kaj moznosti spreminjati vsebino dogajanja. Ponavadi so raziskave dovolj obsezne, da so napake tezko opazne, ali pa jih sploh ni.`}</p>
    <p>{`Potem pa imamo se dela, ki puscajo zevajoce luknje v karakterjih in splosnem dogajanju. Eden takih je `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/It_crowd"
      }}>{`The IT Crowd`}</a>{`. Ne razumite narobe, nanizanka je odlicna in ena redkih, ki cloveka se lahko nasmeje tako kot Monty Python, vsaj vsakogar, ki je vsaj malo geeka.`}</p>
    <p>{`V eni od epizod sta oba geeka prikazana pri ocitni uporabi Internet Explorer 6. Prav, veliko ljudi ga uporablja, ampak, da ga uporabljata dve osebi takega kova je pa nepredstavljivo. Ni kot, da so spregledali neko majhno podrobnost, in ni kot, da je bilo splosno poglabljanje slabo, saj imajo celo `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Flying_spaghetti_monster"
      }}>{`Leteco spagetarsko posast`}</a>{`. Veliki problem tu je, da je `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Browser_war"
      }}>{`Brskalniska vojna`}</a>{` ze zelo star pojav, ki se je zacel ze v davnem 1995, kar je zacuda stareje od Googla. Lahko oprostimo dejstvo, da uporabljata windowse, ker pac delata za veliko podjetje v majhnem racunalniskem oddelku, ampak IE je pa preko vseh razumnih meja. Nekdo bi moral napisati jezno pismo ustvarjalcem te nanizanke.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      